import React from 'react';
import { ErrorBoundaryProps, ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { ErrorPage } from '@/pages/ErrorPage';

export const ErrorBoundary: React.FC<Pick<ErrorBoundaryProps, 'children'>> = ({ children }) => (
  <ReactErrorBoundary
    FallbackComponent={ErrorPage}
    onError={(error, info) => {
      // Log to Sentry or analytics
      console.error('Error boundary caught:', error, info);
    }}
  >
    {children || <Outlet />}
  </ReactErrorBoundary>
);
